import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/no-array-index-key */

/* eslint-disable react/no-unused-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TrustPilotRatingLogo, DomesticAndGeneralLogo } from '@sainsburys-tech/bolt-icons';
import TrolleyItem from '../TrolleyItem/TrolleyItem';
import CategoryItem from '../CategoryItem/CategoryItem';
import WarrantyItem from '../WarrantyItem/WarrantyItem';
import { onWarrantiesLoaded } from '../../helpers/tracking';
import careTypes from '../WarrantyItem/config/careTypes';
import * as Styled from './TrolleyItemList.styles';

var DynamicWrapper = function DynamicWrapper(_ref) {
  var itemType = _ref.itemType,
      itemsData = _ref.itemsData,
      primaryCare = _ref.primaryCare,
      careCount = _ref.careCount,
      children = _ref.children;

  if (itemType === 'warranty') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.ItemWrapper, {
      isOneChild: children.length === 1
    }, children), /*#__PURE__*/React.createElement(Styled.KeyExclusions, {
      dangerouslySetInnerHTML: {
        __html: careCount === 1 ? primaryCare.keyExclusionsSingular : primaryCare.keyExclusionsPlural
      },
      "data-test": "key-exclusions"
    }), /*#__PURE__*/React.createElement(Styled.CareProviderContainer, null, /*#__PURE__*/React.createElement(Styled.DGLogoContainer, null, careTypes[itemsData[0].type].provider, /*#__PURE__*/React.createElement(DomesticAndGeneralLogo, {
      width: 85,
      length: "auto",
      "aria-hidden": "true"
    })), /*#__PURE__*/React.createElement(Styled.TrustPilotLogoContainer, null, /*#__PURE__*/React.createElement(TrustPilotRatingLogo, {
      width: 200,
      length: "auto",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement(Styled.TrustPilotRating, null, careTypes[itemsData[0].type].trustPilotRating))));
  }

  return children;
};

var TrolleyItemList = function TrolleyItemList(_ref2) {
  var _itemsAttributes$trac, _children$;

  var items = _ref2.items,
      itemsAttributes = _ref2.itemsAttributes,
      itemsData = _ref2.itemsData,
      itemType = _ref2.itemType,
      hideIfEmpty = _ref2.hideIfEmpty,
      products = _ref2.products,
      onClick = _ref2.onClick,
      showQuantity = _ref2.showQuantity,
      showButton = _ref2.showButton,
      showPrice = _ref2.showPrice,
      trackingOptions = _ref2.trackingOptions,
      children = _ref2.children,
      moduleIndex = _ref2.moduleIndex,
      primaryCare = _ref2.primaryCare,
      careCount = _ref2.careCount,
      hideMonthlyCareCTA = _ref2.hideMonthlyCareCTA,
      dataTest = _ref2['data-test'];
  var hostProductQuantity = itemsAttributes && ((_itemsAttributes$trac = itemsAttributes[trackingOptions.mainProductId]) === null || _itemsAttributes$trac === void 0 ? void 0 : _itemsAttributes$trac.quantity) || 1;
  useEffect(function () {
    var _products$trackingOpt;

    if (itemType === 'warranty' && (_products$trackingOpt = products[trackingOptions.mainProductId]) !== null && _products$trackingOpt !== void 0 && _products$trackingOpt.data) {
      onWarrantiesLoaded(itemsData, products[trackingOptions.mainProductId], hostProductQuantity);
    }
  }, []);
  var COMMON_TRACKING_OPTIONS = {
    placement: 'attLightbox',
    strategy: 'xsell'
  };

  var categoryTrackingOptions = _objectSpread(_objectSpread(_objectSpread({}, trackingOptions), COMMON_TRACKING_OPTIONS), {}, {
    innerPlacement: ['category'].includes(itemType) ? items[0].model : '',
    sectionTitle: 'HYTA'
  });

  var trolleyItemTrackingOptions = _objectSpread(_objectSpread(_objectSpread({}, trackingOptions), COMMON_TRACKING_OPTIONS), {}, {
    innerPlacement: ['extra', 'warranty'].includes(itemType) ? itemsData[0].model : '',
    sectionTitle: ['warranty'].includes(itemType) && (_children$ = children[0]) !== null && _children$ !== void 0 && _children$.props.children ? 'IYPWAC' : 'YMAL' // Title acronyms Insure Your product with Argos care and You may also like

  });

  var show = !hideIfEmpty || items.length !== 0;
  var displayableItems = items.filter(function (item) {
    var isProduct = typeof item === 'string';
    var showItem = isProduct ? !!products[item] : true;
    return showItem;
  });
  return show && displayableItems.length > 0 && /*#__PURE__*/React.createElement(Styled.List, {
    itemType: itemType,
    "data-test": "section-".concat(itemType)
  }, children, /*#__PURE__*/React.createElement(DynamicWrapper, {
    itemType: itemType,
    itemsData: itemsData,
    primaryCare: primaryCare,
    careCount: careCount
  }, displayableItems.map(function (partNumber, index) {
    var quantity = itemsAttributes && itemsAttributes[partNumber] && itemsAttributes[partNumber].quantity || 1;

    switch (itemType) {
      case 'category':
        return /*#__PURE__*/React.createElement(CategoryItem, {
          key: index,
          moduleIndex: moduleIndex,
          categoryId: items[index].id,
          attributes: items[index].attributes,
          itemType: itemType,
          trackingOptions: categoryTrackingOptions,
          onClick: onClick,
          "data-test": dataTest
        });

      case 'warranty':
        {
          var careData = itemsData.find(function (itemData) {
            return itemData.id === partNumber;
          });
          return /*#__PURE__*/React.createElement(WarrantyItem, {
            hideMonthlyCareCTA: hideMonthlyCareCTA,
            key: index,
            moduleIndex: moduleIndex,
            partNumber: partNumber,
            productInfo: products[partNumber],
            itemType: itemType,
            subType: careData ? careData.type : 'normal',
            trackingOptions: trolleyItemTrackingOptions,
            quantity: hostProductQuantity,
            onClick: onClick,
            "data-test": careData.type.startsWith('monthly_care') ? "".concat(dataTest, "-monthly") : dataTest,
            careData: careData
          });
        }

      default:
        return /*#__PURE__*/React.createElement(TrolleyItem, {
          key: index,
          moduleIndex: moduleIndex,
          partNumber: partNumber,
          productInfo: products[partNumber],
          itemType: itemType,
          subType: itemsData ? itemsData[index].type : 'normal',
          showQuantity: showQuantity,
          showButton: showButton,
          showPrice: showPrice,
          trackingOptions: trolleyItemTrackingOptions,
          quantity: quantity,
          onClick: onClick,
          "data-test": dataTest
        });
    }
  })));
};

TrolleyItemList.propTypes = {
  items: PropTypes.array,
  itemsAttributes: PropTypes.object,
  itemsData: PropTypes.array,
  itemType: PropTypes.string,
  showButton: PropTypes.bool,
  showPrice: PropTypes.bool,
  hideIfEmpty: PropTypes.bool,
  trackingOptions: PropTypes.object,
  showLoadingIfEmpty: PropTypes.bool,
  hideMonthlyCareCTA: PropTypes.bool
};
TrolleyItemList.defaultProps = {
  hideIfEmpty: true,
  showButton: true,
  showPrice: true,
  showLoadingIfEmpty: false,
  itemType: 'normal',
  trackingOptions: {},
  hideMonthlyCareCTA: false
};
export default TrolleyItemList;